@if (alertAlterarEmpresa) {
  <div class="body-alert">
    <div class="tamanhoBox text-center ">
      <div class="row">
        <div class="col-lg-12 ta-right">
          <button
            class="btn-icon"
            aria-label="Fechar"
            (click)="cancelarAlterarEmpresa()"
            >
            <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="content mt-3">
        <p class="title">Alterar empresa</p>
        <p class="subtitle"> Você tem certeza que deseja trocar de empresa?</p>
        <p class="subtitle ta-left">De: <strong>{{nomeEmpresaLogada | camelCase}} (CNPJ:
        {{cnpjEmpresaLogada | cnpj}})</strong> </p>
        <img class=" mb-4 imagem" src="/assets/img/icon-troca.png" alt="Troca de empresa" width="28px"
          height="28px">
        <p class="subtitle ta-left">Para: <strong>{{nomeEmpresaDestino | camelCase}} (CNPJ:
        {{cnpjEmpresaDestino | cnpj}})</strong></p>
      </div>
      <div class="col-12 mt-4">
        <button class="botao mb-0" (click)="onSubmit()" [ngClass]="{'disabled': cnpjEmpresaLogada == cnpjEmpresaDestino}"
        [disabled]="cnpjEmpresaLogada == cnpjEmpresaDestino">ALTERAR EMPRESA</button>
      </div>
      <div class="col-12 mt-2">
        <button class="botao-outline buttonCancelar mb-0" (click)="cancelarAlterarEmpresa()">CANCELAR</button>
      </div>
    </div>
  </div>
}